(function() {
    'use strict';

    angular
        .module('app.companias')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/seleccionar-compania',
                config: {
                    templateUrl: 'app/companias/seleccionarCompania.html',
                    controller: 'SeleccionarCompania',
                    controllerAs: 'vm',
                    title: 'Seleccionar Compania'
                }
            }
        ];
    }
})();
